import React, { FC } from "react";

interface Props {
  noMargin?: boolean;
}

export const PreviewTag: FC<Props> = ({ noMargin = false }) => {
  return (
    <div
      className={`py-1 px-4 text-white bg-gray-400 text-center block ${
        noMargin ? "" : "mb-4"
      }`}
    >
      PREVIEW
    </div>
  );
};
